// Display labels are distinct from the unchanged official exchange abbreviation.
export function fundDisplayName(fund) {
  if (!fund) return '';
  const display = typeof fund.reitsName === 'string' ? fund.reitsName.trim() : '';
  const official = typeof fund.reitsNameSe === 'string' ? fund.reitsNameSe.trim() : '';
  if (fund.reitsTypeL0 === '商业不动产' && display) {
    // BIE supplies the qualified display name; do not infer product type from words.
    return display.endsWith('REIT') ? display : `${display}REIT`;
  }
  return official || display;
}

export function resolveFundSelection(item, fromChart, funds) {
  if (!item) return null;
  const code = fromChart ? item[1] : item.reitCode;
  if (typeof code !== 'string' || !/^\d{6}\.(SH|SZ)$/.test(code)) return null;
  const fund = (funds || []).find(row => row.reitCode === code);
  const fallback = fromChart ? item[0] : item.value;
  return { code, name: fundDisplayName(fund) || fallback || code };
}

export function refreshSelectedFundName(storage, funds) {
  const code = storage.getItem('CURRENTCODE');
  const fund = (funds || []).find(row => row.reitCode === code);
  const name = fundDisplayName(fund);
  if (name) storage.setItem('CURRENTNAME', name);
}
